import CableReady from 'cable_ready';
import reflexes from './reflexes';
import { XPathToElement } from './utils';
import { dispatchLifecycleEvent } from './lifecycle';
import Log from './log';

var beforeDOMUpdate = function beforeDOMUpdate(event) {
  var _ref = event.detail || {},
      stimulusReflex = _ref.stimulusReflex,
      payload = _ref.payload;

  if (!stimulusReflex) return;
  var reflexId = stimulusReflex.reflexId,
      xpathElement = stimulusReflex.xpathElement,
      xpathController = stimulusReflex.xpathController;
  var controllerElement = XPathToElement(xpathController);
  var reflexElement = XPathToElement(xpathElement);
  var reflex = reflexes[reflexId];
  var promise = reflex.promise;
  reflex.pendingOperations--;
  if (reflex.pendingOperations > 0) return;
  if (!stimulusReflex.resolveLate) setTimeout(function () {
    return promise.resolve({
      element: reflexElement,
      event: event,
      data: promise.data,
      payload: payload,
      reflexId: reflexId,
      toString: function toString() {
        return '';
      }
    });
  });
  setTimeout(function () {
    return dispatchLifecycleEvent('success', reflexElement, controllerElement, reflexId, payload);
  });
};

var afterDOMUpdate = function afterDOMUpdate(event) {
  var _ref2 = event.detail || {},
      stimulusReflex = _ref2.stimulusReflex,
      payload = _ref2.payload;

  if (!stimulusReflex) return;
  var reflexId = stimulusReflex.reflexId,
      xpathElement = stimulusReflex.xpathElement,
      xpathController = stimulusReflex.xpathController;
  var controllerElement = XPathToElement(xpathController);
  var reflexElement = XPathToElement(xpathElement);
  var reflex = reflexes[reflexId];
  var promise = reflex.promise;
  reflex.completedOperations++;
  Log.success(event, false);
  if (reflex.completedOperations < reflex.totalOperations) return;
  if (stimulusReflex.resolveLate) setTimeout(function () {
    return promise.resolve({
      element: reflexElement,
      event: event,
      data: promise.data,
      payload: payload,
      reflexId: reflexId,
      toString: function toString() {
        return '';
      }
    });
  });
  setTimeout(function () {
    return dispatchLifecycleEvent('finalize', reflexElement, controllerElement, reflexId, payload);
  });
  if (reflex.piggybackOperations.length) CableReady.perform(reflex.piggybackOperations);
};

var routeReflexEvent = function routeReflexEvent(event) {
  var _ref3 = event.detail || {},
      stimulusReflex = _ref3.stimulusReflex,
      payload = _ref3.payload,
      name = _ref3.name,
      body = _ref3.body;

  var eventType = name.split('-')[2];
  if (!stimulusReflex || !['nothing', 'halted', 'error'].includes(eventType)) return;
  var reflexId = stimulusReflex.reflexId,
      xpathElement = stimulusReflex.xpathElement,
      xpathController = stimulusReflex.xpathController;
  var reflexElement = XPathToElement(xpathElement);
  var controllerElement = XPathToElement(xpathController);
  var reflex = reflexes[reflexId];
  var promise = reflex.promise;

  if (controllerElement) {
    controllerElement.reflexError = controllerElement.reflexError || {};
    if (eventType === 'error') controllerElement.reflexError[reflexId] = body;
  }

  switch (eventType) {
    case 'nothing':
      nothing(event, payload, promise, reflex, reflexElement);
      break;

    case 'error':
      error(event, payload, promise, reflex, reflexElement);
      break;

    case 'halted':
      halted(event, payload, promise, reflex, reflexElement);
      break;
  }

  setTimeout(function () {
    return dispatchLifecycleEvent(eventType, reflexElement, controllerElement, reflexId, payload);
  });
  if (reflex.piggybackOperations.length) CableReady.perform(reflex.piggybackOperations);
};

var nothing = function nothing(event, payload, promise, reflex, reflexElement) {
  reflex.finalStage = 'after';
  Log.success(event, false);
  setTimeout(function () {
    return promise.resolve({
      data: promise.data,
      element: reflexElement,
      event: event,
      payload: payload,
      reflexId: promise.data.reflexId,
      toString: function toString() {
        return '';
      }
    });
  });
};

var halted = function halted(event, payload, promise, reflex, reflexElement) {
  reflex.finalStage = 'halted';
  Log.success(event, true);
  setTimeout(function () {
    return promise.resolve({
      data: promise.data,
      element: reflexElement,
      event: event,
      payload: payload,
      reflexId: promise.data.reflexId,
      toString: function toString() {
        return '';
      }
    });
  });
};

var error = function error(event, payload, promise, reflex, reflexElement) {
  reflex.finalStage = 'after';
  Log.error(event);
  setTimeout(function () {
    return promise.reject({
      data: promise.data,
      element: reflexElement,
      event: event,
      payload: payload,
      reflexId: promise.data.reflexId,
      error: event.detail.body,
      toString: function toString() {
        return event.detail.body;
      }
    });
  });
};

export { beforeDOMUpdate, afterDOMUpdate, routeReflexEvent };